module.exports = __webpack_public_path__ + "img/printer_active.3f96e3e6.svg";